import { Request } from '@iss/libs/graphql';
import { Pipe, PipeTransform } from '@angular/core';

type RequestIdArg = Pick<Request, 'businessId'>;

@Pipe({ name: 'requestId', standalone: true })
export class RequestIdPipe implements PipeTransform {
  public transform(value: RequestIdArg): string {
    return value.businessId;
  }
}
